export default "__VITE_ASSET__CbS1c9VO__"